import BaseService from './BaseService';
import entities from 'src/config/entities';
import axios from "axios/index";


class DashboardService extends BaseService {

  constructor() {
    super({ entity: entities.DASHBOARD });
  }

  async getDashboard(range = 'today') {
    try {
      return await axios.get(`/dashboard`, {
        params: {
          date_range: range
        }
      });
    } catch (e) {
      this._handleError({ translationKey: 'generic.get.error', error: e });
      throw e;
    }
  }

}

export default new DashboardService();
